module.exports = __webpack_public_path__ + "img/jingpin.11945d29.png";